export default "__VITE_ASSET__CR1Aw5ev__"